
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageTransition from "@/components/PageTransition";
import { Helmet } from "react-helmet";

const TermsOfService = () => {
  return (
    <PageTransition>
      <Helmet>
        <title>Terms of Service | Los Angeles SEO Group</title>
        <meta 
          name="description" 
          content="Los Angeles SEO Group's terms of service. Learn about the terms and conditions for using our services."
        />
      </Helmet>
      
      <Navbar />
      
      <div className="page-container pt-32 pb-20">
        <h1 className="text-3xl md:text-4xl font-bold mb-6">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          <p>Last updated: March 2023</p>
          
          <h2>1. Introduction</h2>
          <p>
            These terms and conditions outline the rules and regulations for the use of Los Angeles SEO Group's website.
            By accessing this website, we assume you accept these terms and conditions in full. Do not continue to use 
            Los Angeles SEO Group's website if you do not accept all of the terms and conditions stated on this page.
          </p>
          
          <h2>2. License</h2>
          <p>
            Unless otherwise stated, Los Angeles SEO Group and/or its licensors own the intellectual property rights 
            for all material on this website. All intellectual property rights are reserved. You may view and/or print 
            pages from the website for your own personal use subject to restrictions set in these terms and conditions.
          </p>
          
          <p>You must not:</p>
          <ul>
            <li>Republish material from this website</li>
            <li>Sell, rent or sub-license material from this website</li>
            <li>Reproduce, duplicate or copy material from this website</li>
            <li>Redistribute content from Los Angeles SEO Group (unless content is specifically made for redistribution)</li>
          </ul>
          
          <h2>3. User Comments</h2>
          <p>
            Certain parts of this website offer the opportunity for users to post and exchange opinions, information, 
            material and data. Los Angeles SEO Group does not screen, edit, publish or review Comments prior to their 
            appearance on the website and Comments do not reflect the views or opinions of Los Angeles SEO Group, its 
            agents or affiliates. Comments reflect the view and opinion of the person who posts such view or opinion.
          </p>
          
          <h2>4. Content Liability</h2>
          <p>
            We shall have no responsibility or liability for any content appearing on your website. You agree to 
            indemnify and defend us against all claims arising out of or based upon your website. No link(s) may 
            appear on any page on your website or within any context containing content or materials that may be 
            interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates 
            the infringement or other violation of, any third party rights.
          </p>
          
          <h2>5. Reservation of Rights</h2>
          <p>
            We reserve the right at any time and in its sole discretion to request that you remove all links or any particular 
            link to our website. You agree to immediately remove all links to our website upon such request. We also 
            reserve the right to amend these terms and conditions and its linking policy at any time. By continuing 
            to link to our website, you agree to be bound to and abide by these linking terms and conditions.
          </p>
          
          <h2>6. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Service, please contact us at:
          </p>
          <p>
            Email: info@losangelesseogroup.com<br />
            Phone: (323) 784-1577<br />
            Address: 10000 Washington Blvd, Culver City, CA 90232
          </p>
        </div>
      </div>
      
      <Footer />
    </PageTransition>
  );
};

export default TermsOfService;
